<template>
  <div class="wrap">
    <div class="glide multi">
      <div class="glide__track" data-glide-el="track">
        <ul class="glide__slides">
          <li
            v-for="slide in data"
            :key="slide.id"
            :data-slide="slide.id"
            class="glide__slide"
            style="margin: 20px 20px 0 20px;"
          >
            <div class="glide__slide__img-container">
              <img :src="slide.image" />
            </div>
            <div v-if="slide.expirationDate" class="discount"><p >Scadenza<br> carta <br> <b>{{slide.expirationDate}}</b></p></div>
          </li>
        </ul>
      </div>
      <div v-if="this.data.length > 1" class="glide__bullets" data-glide-el="controls[nav]">
        <button
          v-for="(slide, index) in data"
          :key="slide.id"
          class="glide__bullet"
          :data-glide-dir="`=${index}`"
        ></button>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: "SmoothCarousel",
  props: ["data", "onSelect", "startIndex"],
  mounted() {
    console.log("init smooth carousel, with data", this.data);
    this.initSlider();
    this.selectSlide();
  },
  methods: {
    selectSlide() {
      const selectedSlide = window.$(".glide__slide.glide__slide--active");
      const selectedSlideId = parseInt(window.$(selectedSlide).data("slide"));
      if (this.onSelect) {
        this.onSelect(selectedSlideId);
      }
    },
    initSlider() {
      const that = this;
      const glide = new window.Glide(".multi", {
        type: "slider",
        focusAt: "center",
        perView: 2,
        startAt: this.startIndex || 0,
        dragThreshold: this.data.length < 2 ? false : 120, // disabilito il drag se c'è una sola card
        swipeThreshold: this.data.length < 2 ? false : 80, // disabilito lo swipe mobile se c'è una sola card
      });

      glide.on(["move"], function(move) {
        const elem_size = window.$(".glide__slide--active").width() + 3;
        const elem_margin = 5;
        const tot_elem = elem_size + elem_margin;
        const position = move.movement / tot_elem;
        //const currentIndex = window.$(".glide__slide--active").index();
        const step = parseInt(position);
        //const isMovingRight = step === currentIndex;
        //const isMovingLeft = !isMovingRight;
        let perc =
          parseInt((position - step) * 100) === 0
            ? 1
            : parseInt((position - step) * 100);

        //preventing errors on max and min percentages (ex: 98% will be 100%)
        if (perc > 70) perc = 100;
        if (perc < 20) perc = 0;

        //increasing target card size
        const initialScale = 0.6;
        const remainingScale = 1 - initialScale;
        let increasingScale = initialScale + (perc / 100) * remainingScale;
        if (increasingScale > 1) increasingScale = 1;

        const initialOpacity = 0.8;
        const remainingOpacity = 1 - initialOpacity;
        let increasingOpacity =
          initialOpacity + (perc / 100) * remainingOpacity;

        window
          .$(window.$(".glide__slide")[step + 1])
          .css("transform", `scale(${increasingScale})`)
          .css("filter", `blur(0px)`)
          .css("-webkit-filter", `blur(0px)`)
          .css("opacity", `${increasingOpacity}`);

        //reducing other card size
        let decreasingScale = 1 - (remainingScale / 100) * perc;
        let decreasingOpacity = 1 - (remainingOpacity / 100) * perc;
        window
          .$(window.$(".glide__slide")[step])
          .css("transform", `scale(${decreasingScale})`)
          .css("opacity", `${decreasingOpacity}`);

        window
          .$(window.$(".glide__slide")[step + 2])
          .css("transform", `scale(${decreasingScale})`)
          .css("opacity", `${decreasingOpacity}`);
      });

      glide.on(["run.after"], function() {
        window
          .$(".glide__slide:not(.glide__slide--active)")
          .css("transform", `scale(0.6)`)
          //.css("filter", `blur(2px)`)
          //.css("-webkit-filter", `blur(2px)`)
          .css("opacity", `0.8`);
        window
          .$(".glide__slide.glide__slide--active")
          .css("transform", `scale(1)`)
          //.css("filter", `blur(0px)`)
          //.css("-webkit-filter", `blur(0px)`)
          .css("opacity", `1`);
        that.selectSlide();
      });

      glide.mount();
    }
  }
};
</script>

<style lang="less" scoped>
.glide__slides {
  padding-right: 30px;
  margin-left: -5px;
  box-sizing: content-box;
}
.wrap {
  width: 400px;
  @media (max-width: 320px) {
    width: 300px;
  }
  @media (min-width: 320px) {
    width: 320px;
  }
  @media (min-width: 340px) {
    width: 340px;
  }
  @media (min-width: 360px) {
    width: 360px;
  }
  @media (min-width: 380px) {
    width: 380px;
  }
  margin: 0 auto;
}
.glide__slides {
  padding-bottom: 15px;
}
.glide__slide {
  transform: scale(0.7);
  transition: all 0.2s ease;
  opacity: 0.8;
  //filter: blur(2px);
  //-webkit-filter: blur(2px);

  .glide__slide__img-container {
    box-shadow: 5px 5px 10px -4px #0000007d;
    border-radius: 11px;
  }
  &--active {
    transform: scale(1);
    opacity: 1;
    //box-shadow: 5px 5px 10px -4px #0000007d;
    //filter: blur(0px);
    //-webkit-filter: blur(0px);
  }
}
.glide__bullets {
  bottom: -18px;
  .glide__bullet {
    border: 1px solid #CC4B00;
    &.glide__bullet--active {
      background-color: #CC4B00;
    }
  }
}
.discount {
  position: absolute;
    top: -20px;
    right: -20px;
    width: 70px;
    height: 70px;
    border-radius: 100px;
    color: white;
    font-size: 9px;
    padding: 3px;
    text-align: center;
    display: flex;
    align-items: center;
    transform: rotate(10deg);
    box-shadow: 5px 5px 10px -4px #0000007d;
    background-image: url('../assets/images/bollino.png');
    background-size: contain;
    p {
      margin: 0 auto;
    }
}
</style>
